import { PageDirection, TableDataSource } from "@/shared/components/table/table.model";
import { ClusterInviteFragment, ClusterInvitesGQL } from "@/core/graphql/graphql";
import { PaginatorComponent } from "@/shared/components/table/components/paginator/paginator.component";
import { SearchbarComponent } from "@/shared/components/table/components/searchbar/searchbar.component";
import { MatSort } from "@angular/material/sort";
import { FilterComponent } from "@/shared/components/table/components/filter/filter.component";
import { BehaviorSubject, Observable } from "rxjs";
import { CollectionViewer } from "@angular/cdk/collections";
import {
  CheckboxFilterComponent,
} from "@/shared/components/table/components/checkbox-filter/checkbox-filter.component";

export class ClusterInvitesDatasource extends TableDataSource<ClusterInviteFragment> {
  public paginator: PaginatorComponent;
  public searchbar: SearchbarComponent;
  public sort: MatSort;
  public filter: FilterComponent;
  private _invitesSubject = new BehaviorSubject<ClusterInviteFragment[]>([]);

  public constructor(
    private readonly clusterInvitesGQL: ClusterInvitesGQL,
    private readonly _clusterId: number,
  ) {
    super();
  }

  public set checkboxFilter(component: CheckboxFilterComponent) {
  }

  public connect(_: CollectionViewer): Observable<readonly ClusterInviteFragment[]> {
    return this._invitesSubject.asObservable();
  }

  public disconnect(collectionViewer: CollectionViewer): void {
    this._invitesSubject.complete();
  }

  public onPaginationChange(requestedChange: PageDirection): void {
  }

  public loadData(): void {
    this.clusterInvitesGQL.fetch({
      id: this._clusterId,
      meta: {
        pageSize: 10,
        pageCursor: undefined,
      },
    }).subscribe((x) => {
      this._invitesSubject.next(x.data.cluster.collaborationInvites.items);
    });
  }
}
